import dayjs from 'dayjs';
import { ListTerminEntry } from '@/domain/termine/features/Calendar/List/Termin/ListTerminEntry';
import { Termin } from '@/domain/termine/shared/types/Termin';

interface DayCellMobileEntriesProps {
  day: dayjs.Dayjs;
  termine: Termin[];
}

export function DayCellMobileEntries({ termine }: DayCellMobileEntriesProps) {
  return (
    <div className="flex flex-col">
      <ListTerminEntry
        termine={termine}
        className="flex flex-col gap-2 w-full bg-neutrals-N200"
      />
    </div>
  );
}
